import React, { useState, useRef, useEffect } from 'react'
import {
    Button, Typography, Alert, QRCode, Flex, Table, Badge, Breadcrumb, Card, Checkbox, Modal, Tag, Divider, Drawer, Form,
    Input, Select, InputNumber, DatePicker, ConfigProvider
} from 'antd'
import api from '../../service/axios'
import { useToasts } from 'react-toast-notifications';
import ReactToPrint from 'react-to-print';
import {
    CheckOutlined,
    CloseOutlined,
    DeleteOutlined,
    EditOutlined,
    HomeOutlined,
    LoadingOutlined,
    MailOutlined,
    PhoneOutlined,
    SendOutlined,
    TrophyOutlined
} from '@ant-design/icons';
import { userState } from '../../service/database'
import { useRecoilState } from 'recoil'
import dayjs from 'dayjs';
import ptBR from 'dayjs/locale/pt-br';
import TelefoneBrasileiroInput from "react-telefone-brasileiro";
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import { type } from '@testing-library/user-event/dist/type';

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

dayjs.locale(ptBR);
dayjs.locale('pt-br');

const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

export const RegistradoOportunidade = (props) => {

    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [data, setData] = useState(undefined)
    const [user, setUser] = useRecoilState(userState)
    const [open, setOpen] = useState(false)
    const [openTermos, setOpenTermos] = useState(false)
    const [aceito, setAceito] = useState(false)
    const [selected, setSelected] = useState({})

    const [form] = Form.useForm();
    const [formLayout, setFormLayout] = useState('horizontal');
    const onFormLayoutChange = ({ layout }) => {
        setFormLayout(layout);
    };

    const options = [
        { value: "RASCUNHO", label: "Rascunho" },
        { value: "AGUARDANDO_APROVACAO", Disabled: 'disable', label: "Aguardando Aprovação" },
        //    { value: "PUBLICADA", label: "Publicada", disabled: true },
        //   { value: "SUSPENSA", label: "Suspensa", disabled: true },
        { value: "ENCERRADA", label: "Encerrada" },
        //  { value: "EXPIRADA", label: "Expirada" }
    ]

    const onFinish = async (values) => {
        console.log(values, selected);
        try {
            setLoading(true)
            const result = await api.post('/api/v1.0/registrado/oportunidades', selected, {
                headers: {
                    'x-access-token': user?.token2
                }
            })
            setSelected(result.data)
            setLoading(false)
            setOpen(false)
            consulta()
        } catch (error) {
            addToast(error.message, { appearance: 'error', autoDismiss: true })
        }
        setLoading(false)
    };



    useEffect(() => {
        if (user) {
            //  console.log(user)
            consulta()
        }
    }, [])


    async function consulta() {
        try {
            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/oportunidades', {
                headers: {
                    'x-access-token': user?.token2
                }
            })
            setData(result.data)
            console.log(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }

        setLoading(false)
    }




    function renderStatus(item) {
        switch (item.status) {
            case "PUBLICADA":
                return <Tag color={'royalblue'} variant='solid'>Publicada</Tag>
            case "RASCUNHO":
                return <Tag color={'gray'} variant='solid'>Rascunho</Tag>
            case "AGUARDANDO_APROVACAO":
                return <Tag color={'volcano'} variant='solid'>Aguardando Aprovação</Tag>
            case "SUSPENSA":
                return <Tag color={'purple'} variant='solid'>Suspensa</Tag>
            case "ENCERRADA":
                return <Tag color={'magenta'} variant='solid'>Encerrada</Tag>
            case "EXPIRADA":
                return <Tag color={'red'} variant='solid'>Expirada</Tag>
        }

    }


    return <Flex vertical>
        <Flex align='center' justify='space-between' >
            <Flex gap={20}>
                <Breadcrumb
                    items={[
                        {
                            href: '',
                            title: (
                                <>
                                    <TrophyOutlined />
                                    <span>Oportunidades {user?.isprofissional === 0 ? 'Cadastradas' : ''}</span>
                                </>
                            ),
                        },

                    ]}
                />



            </Flex>
            <Flex gap={5}>
                {user.isprofissional === 0 ? <Button size='small' type='primary' onClick={() => {
                    const init = {
                        status: 'AGUARDANDO_APROVACAO',
                        salario: 'A combinar',
                        data_publicacao: dayjs(),
                        data_expiracao: dayjs().add(15, 'day'),
                        vagas: undefined,
                        titulo: '',
                        descricao: '',
                        email: '',
                        requisitos: '',
                        telefone: '',
                        id:0

                    }
                    form.resetFields([init])
                    setSelected(init)
                    setOpen(true)
                }}>Cadastrar </Button>
                    :
                    <Flex gap={5}>
                        <Checkbox checked={aceito} onChange={(e) => setAceito(e.target.checked)}></Checkbox> Aceito os <a onClick={() => {
                            setOpenTermos(!openTermos)
                        }}>termos</a> de uso.
                    </Flex>
                }
            </Flex>

        </Flex>
        <Divider style={{ marginTop: 5, marginBottom: 5 }} />
        <Flex gap={10} vertical>
            {loading && <Flex gap={5}> <LoadingOutlined /> carregando dados... </Flex>}
            {
                data && data.map((item, index) => {
                    return <Card size='small' key={"oportunidade:" + item.id} style={{ width: '100%' }}
                        title={<Flex align='center' justify='space-between' >
                            <b style={{ color: 'royalblue', fontWeight: 'bold' }}>{item.titulo.toUpperCase()}</b>
                            <Flex style={{ fontSize: '0.9em', color: 'gray', fontStyle: 'normal' }}>
                                Publicada em {dayjs(item.data_publicacao).format('DD/MM/YYYY')}
                            </Flex>
                        </Flex>}>
                        <Flex vertical>
                            <Flex justify='space-between'>
                                <Flex>{item.fantasia}</Flex>
                                <Flex><Button type='text' size='small' icon={<EditOutlined />}
                                    onClick={() => {
                                        let aux = { ...selected }
                                        aux.Requisitos = aux.requisitos
                                        console.log(item)
                                        setSelected(item)
                                        setOpen(true)
                                    }}></Button></Flex>
                            </Flex>
                            <Flex gap={5}><b>{item.vagas} {item.vagas === 1 ? ' vaga:' : ' vagas:'}</b> {item.cidade} - {item.uf}</Flex>
                            <Flex>{item.salario ? item.salario : 'A combinar'}</Flex>
                            <Flex>{item.descricao}</Flex>
                            {
                                user.isprofissional === 1 ? <Flex>
                                    {aceito ? <Flex gap={25} style={{ marginTop: 3 }}>
                                        <Flex gap={5}><MailOutlined />{item.email}</Flex>
                                        <Flex gap={5}><PhoneOutlined />{item.telefone}</Flex>
                                    </Flex>
                                        :
                                        <Flex>
                                            <Flex gap={5} style={{ color: 'red' }}><MailOutlined />Aceite os termos de uso para visualizar os dados de contato</Flex>
                                        </Flex>
                                    }
                                </Flex>
                                    :
                                    <Flex gap={25} style={{ marginTop: 3 }}>
                                        <Flex gap={5}><MailOutlined />{item.email}</Flex>
                                        <Flex gap={5}><PhoneOutlined />{item.telefone}</Flex>
                                    </Flex>
                            }


                            {user?.isprofissional === 0 && <Flex gap={5} justify='space-between'> <Flex>  {renderStatus(item)} </Flex>
                            <Flex style={{color:'gray', fontStyle:'italic', fontSize:'0.9em'}}> Expira em {dayjs(selected.data_expiracao).format('DD/MM/YYYY')} </Flex>
                            </Flex>}

                        </Flex>

                    </Card>
                })
            }
            {
                data && data.length === 0 && user?.isprofissional === 1 && <Card title={<Flex style={{ fontWeight: 'bold' }}>
                    Sem Oportunidades hoje!😔
                </Flex>}>
                    <Flex> Não encontramos nenhuma vaga cadastrada em nosso banco de dados, volte em outro momento. </Flex>
                </Card>
            }
        </Flex>


        {
            <Modal
                width={'80%'}
                onCancel={() => setOpenTermos(false)}
                open={openTermos}
                centered
                title={"TERMO DE USO DO SERVIÇO DE DIVULGAÇÃO DE VAGAS DE EMPREGO – MeuCRQCE"}
                footer={<Flex justify='flex-end' gap={10}>
                    <Button onClick={() => setOpenTermos(false)}>Fechar</Button>
                    <Button type='primary' onClick={() => {
                        setAceito(true)
                        setOpenTermos(false)
                    }}>Aceito</Button>
                </Flex>}>


                <div class="container">


                    <h3>1. Objeto</h3>
                    <p>
                        O presente Termo de Uso tem por objetivo estabelecer as condições para utilização do serviço de
                        <span class="highlight">divulgação de vagas de emprego</span>, disponibilizado por meio da plataforma
                        <span class="highlight">MeuCRQCE</span>, destinada aos profissionais e empresas registrados no CRQ-CE.
                    </p>

                    <h3>2. Do Cadastro e Responsabilidade das Empresas</h3>
                    <p>
                        2.1. O cadastro de vagas é de responsabilidade exclusiva das <span class="highlight">empresas registradas
                            e com situação regular</span> junto ao Conselho.
                    </p>
                    <p>
                        2.2. A empresa declarante afirma que todas as informações fornecidas são verdadeiras, atualizadas e compatíveis
                        com a legislação vigente.
                    </p>
                    <p>
                        2.3. A empresa é integralmente responsável pelo conteúdo da vaga divulgada, incluindo requisitos,
                        atribuições, remuneração e condições de trabalho.
                    </p>

                    <h3>3. Da Moderação e Publicação</h3>
                    <p>
                        3.1. O CRQ-CE reserva-se o direito de analisar, aprovar, suspender ou remover vagas que estejam em desacordo
                        com este Termo ou com normas legais e éticas.
                    </p>
                    <p>
                        3.2. A publicação da vaga poderá ocorrer de forma automática ou mediante aprovação prévia, conforme regras
                        internas do Conselho.
                    </p>

                    <h3>4. Das Vedações</h3>
                    <p>É vedada a publicação de vagas que:</p>
                    <ul>
                        <li>Exijam atribuições incompatíveis com a formação profissional;</li>
                        <li>Contenham conteúdo discriminatório, ofensivo ou ilegal;</li>
                        <li>Apresentem informações falsas ou enganosas;</li>
                        <li>Utilizem o espaço para fins diversos da oferta de emprego.</li>
                    </ul>

                    <h3>5. Da Isenção de Responsabilidade do Conselho</h3>
                    <p>
                        5.1. O CRQ-CE não se responsabiliza pelo conteúdo das vagas divulgadas, nem pelo processo seletivo,
                        contratação ou relação trabalhista entre empresa e candidato.
                    </p>
                    <p>
                        5.2. O Conselho atua exclusivamente como provedor do espaço digital para divulgação das oportunidades.
                    </p>

                    <h3>6. Da Vigência das Vagas</h3>
                    <p>
                        6.1. As vagas terão prazo de exibição definido no momento do cadastro ou conforme regras estabelecidas pela
                        plataforma.
                    </p>
                    <p>
                        6.2. O encerramento poderá ocorrer automaticamente por expiração de prazo ou manualmente pela empresa
                        responsável.
                    </p>

                    <h3>7. Da LGPD e Proteção de Dados</h3>
                    <p>
                        7.1. Os dados informados serão tratados conforme a Lei Geral de Proteção de Dados
                        (<span class="highlight">Lei nº 13.709/2018</span>).
                    </p>
                    <p>
                        7.2. O uso das informações é restrito às finalidades previstas neste serviço.
                    </p>

                    <h3>8. Disposições Finais</h3>
                    <p>
                        8.1. O uso do serviço implica na aceitação integral deste Termo.
                    </p>
                    <p>
                        8.2. O CRQ-CE poderá alterar este Termo a qualquer tempo, mediante atualização na plataforma.
                    </p>

                    <footer>
                        © MeuCRQCE – Conselho Regional de Química • Todos os direitos reservados
                    </footer>
                </div>



            </Modal>
        }

        {
            open && <Drawer
                size={'80%'}
                open={open}
                closable={false}
                destroyOnHidden={true}
                title={<Flex align='center'>Cadastro de Oportunidades</Flex>}>
                <Form
                preserve={false}
                    id='form-oportunidades'
                    layout={formLayout}
                    form={form}
                    onFinish={onFinish}
                    initialValues={selected.id > 0 ? selected : undefined}
                    onValuesChange={onFormLayoutChange}
                    style={{ maxWidth: formLayout === 'inline' ? 'none' : '100%' }}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Form.Item label="Título da Vaga" name={'titulo'} rules={[{ required: true, type: 'string' }]} required>
                        <Input placeholder="Título" value={selected.titulo}
                            defaultValue={selected.titulo}
                            onChange={(e) => {
                                setSelected({ ...selected, titulo: e.target.value })
                            }} />
                    </Form.Item>
                    <Form.Item label="Descrição" rules={[{ required: true }]} name={'descricao'} required>
                        <Input.TextArea autoSize placeholder="Descrição aqui com o máximo de detalhes possível"
                            defaultValue={selected.descricao}
                            maxLength={255}
                            value={selected.descricao} onChange={(e) => {
                                setSelected({ ...selected, descricao: e.target.value })
                            }} />
                    </Form.Item>
                    <Form.Item label="Requisitos" name={'requisitos'}>
                        <Input placeholder="Requisitos" value={selected.requisitos}
                            defaultValue={selected.requisitos}
                            onChange={(e) => {
                                setSelected({ ...selected, requisitos: e.target.value })
                            }} />
                    </Form.Item>
                    <Form.Item label="Salário">
                        <Input placeholder="Valor do salário" maxLength={100} value={selected.salario} onChange={(e) => {
                            setSelected({ ...selected, salario: e.target.value })
                        }} />
                    </Form.Item>
                    <Form.Item label="Vagas" required name={'vagas'} rules={[{ required: true, type: 'number', min: 1, max: 50 }]}>
                        <InputNumber
                            defaultValue={selected.vagas}
                            min={1} max={50}
                            placeholder="vagas"
                            value={selected.vagas? selected.vagas : 1}
                            onChange={(e) => {
                                setSelected({ ...selected, vagas: e })
                            }} />
                    </Form.Item>
                    <Form.Item label="E-mail de contato" required name={'email'} rules={[{ required: true, type: 'email' }]}>
                        <Input placeholder="E-mail de contato"
                            defaultValue={selected.email}
                            maxLength={150} 
                            value={selected.email} 
                            onChange={(e) => {
                                setSelected({ ...selected, email: e.target.value })
                            }} />
                    </Form.Item>
                    <Form.Item label="Telefone" rules={[{ type: 'tel' }]}>
                        <TelefoneBrasileiroInput
                            defaultValue={selected.email}
                            temDDD
                            separaDDD
                            separaNono={false}
                            className='ant-input css-dev-only-do-not-override-1d8anct ant-input-outlined css-var-root ant-input-css-var'
                            style={{ width: 300 }}
                            placeholder="Telefone" maxLength={50} value={selected.telefone} onChange={(e) => {
                                setSelected({ ...selected, telefone: e.target.value })
                            }} />
                    </Form.Item>
                    <Form.Item label="Data publicação" required name={'publicação'}>
                        <ConfigProvider locale={ptBR}>
                            <DatePicker placeholder="data da publicação"
                                format={"DD/MM/YYYY"}
                                minDate={dayjs()}
                                allowClear={false}
                                value={dayjs(selected.data_publicacao)}
                                onChange={(e, datastring) => {
                                    setSelected({ ...selected, data_publicacao: e })
                                }} />
                        </ConfigProvider>
                    </Form.Item>
                    <Form.Item label="Expirar em" required name={'expiracão'} rules={[{ type: 'date' }]}>
                        <ConfigProvider locale={ptBR}>
                            <DatePicker placeholder="Data de expiração"
                                allowClear={false}
                                minDate={dayjs(selected.data_publicacao).add(1,'D')}
                                format={"DD/MM/YYYY"}
                                value={dayjs(selected?.data_expiracao)}
                                onChange={(e, datastring) => {
                                    console.log(e, datastring)
                                    setSelected({ ...selected, data_expiracao: e })
                                }} />
                        </ConfigProvider>
                    </Form.Item>
                    <Form.Item label="Status" required name={'status'}>
                        <Select
                            style={{ width: 300 }}
                            placeholder="Status da vaga" value={selected.status} onChange={(e) => {
                                setSelected({ ...selected, status: e })
                            }}
                            options={options}>

                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <Divider style={{ marginTop: 10 }} />
                    </Form.Item>

                    <Form.Item>
                        <Flex gap={5} justify='center'>
                            <Checkbox checked={aceito} onChange={(e) => setAceito(e.target.checked)}></Checkbox> Aceito os <a onClick={() => {
                                setOpenTermos(!openTermos)
                            }}>termos</a> de uso.
                        </Flex>
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Flex gap={20}>
                            <Button onClick={() => { 
                                
                                setOpen(false)}}>Voltar</Button>
                            <Button type="primary" htmlType="submit" loading={loading} disabled={!aceito}>Salvar</Button>
                        </Flex>
                    </Form.Item>
                </Form>

            </Drawer>
        }

    </Flex>





}